import React from 'react'
import { Property } from 'csstype'
import styled, { useTheme } from 'styled-components'

import { ThemeColor } from 'theme/colors'
import { ThemeSpace } from 'theme/spaces'
import { Facebook } from 'components/styled/icon/brands/facebook'
import { LinkedIn } from 'components/styled/icon/brands/linked-in'
import { XTwitter } from 'components/styled/icon/brands/x-twitter'

export interface SvgIconProps {
  type: SvgIconType
  size?: ThemeSpace
  color?: ThemeColor
}

const SvgIconTypes = {
  Facebook: 'facebook',
  LinkedIn: 'linkedin',
  XTwitter: 'x-twitter',
} as const

export type SvgIconType = typeof SvgIconTypes[keyof typeof SvgIconTypes]

const Icons: Record<
  SvgIconType,
  React.FC<{ size: string; color: Property.Color }>
> = {
  [SvgIconTypes.Facebook]: Facebook,
  [SvgIconTypes.LinkedIn]: LinkedIn,
  [SvgIconTypes.XTwitter]: XTwitter,
}

const StyledSvgIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`

export const SvgIcon: React.FC<SvgIconProps> = ({
  type,
  size,
  color,
  ...props
}) => {
  const IconComponent = Icons[type]
  const theme = useTheme()
  const iconSize = size ? theme.space[size] : theme.space.s20
  const iconColor = color ? theme.color[color] : 'inherit'

  return (
    <StyledSvgIcon {...props}>
      <IconComponent size={iconSize} color={iconColor} />
    </StyledSvgIcon>
  )
}
